/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Auth_Error_CloseInputs */

const es_login_auth_error_close = /** @type {(inputs: Login_Auth_Error_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const en_login_auth_error_close = /** @type {(inputs: Login_Auth_Error_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Login_Auth_Error_CloseInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_auth_error_close = /** @type {((inputs?: Login_Auth_Error_CloseInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Auth_Error_CloseInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_auth_error_close(inputs)
	return en_login_auth_error_close(inputs)
});
export { login_auth_error_close as "login.auth_error.close" }